import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTooltip,_vm._b({staticClass:"w-tooltip",attrs:{"content-class":`w-tooltip__content-wrapper ${_vm.contentClass}`,"value":_vm.value || _vm.internalShow},on:{"input":_vm.handleInput},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_vm._t("tooltip-activator",null,{"on":on,"attrs":attrs})]}}],null,true)},'v-tooltip',_vm.$props,false),[_c('span',{staticClass:"w-tooltip__content"},[_vm._t("tooltip")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }